// Locale content for NOWI. Locales: en (default), sv (/se), da (/dk), nb (/no)
export const localePath = { en: "/", sv: "/se", da: "/dk", nb: "/no", fi: "/fi", is: "/is", de: "/de" };

const IMG = {
  tech: "https://images.unsplash.com/photo-1619472376731-3ca648a34b69?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team: "https://images.pexels.com/photos/8463167/pexels-photo-8463167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  stockholmHq: "https://images.pexels.com/photos/38334133/pexels-photo-38334133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  stockholmOld: "https://images.pexels.com/photos/30753537/pexels-photo-30753537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  copenhagen: "https://images.pexels.com/photos/20375778/pexels-photo-20375778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  oslo: "https://images.unsplash.com/photo-1608914876485-4e48b8d4b6c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const IMAGES = IMG;
export const SHARED_IMAGES = {
  tech: "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team: "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
export const INSTAGRAM = { handle: "@nowidigital", url: "https://instagram.com/nowidigital" };
export const WHATSAPP = { number: "46728300501", display: "@nowirokert", url: "https://wa.me/46728300501" };
export const CALENDLY = { url: "https://calendly.com/nowidigital/new-meeting" };
export const LEGAL = {
  company: "NOWI Skills AB",
  brand: "NOWI",
  orgNr: "559416-0227",
  vat: "SE559416022701",
  addressLines: ["Storseglet 43, Lgh 1101 Gamage", "136 56 Vega", "Sweden"],
  email: "hello@nowi.digital",
  ig: "@nowidigital",
};
export const WORK = {
  bernedotterUrl: "https://bernedotter.se",
  bernedotterImage: "https://framerusercontent.com/images/ZrJP9wsVmczxzuio35BaLrTutg.webp?width=1920&height=1080",
};

const SERVICE_NUMBERS = ["2026", "2", "48h", "1:1"];
export { SERVICE_NUMBERS };

export const translations = {
  en: {
    langLabel: "EN",
    nav: { solutions: "Solutions", services: "Services", business: "For Business", ventures: "Ventures", about: "About", contact: "Contact", letsTalk: "Let's Talk", smallBusiness: "Small Business" },
    hero: {
      badge: "Stockholm · Sweden — Building across Europe",
      line1: "We build.",
      line2: "We invest.",
      subtitle: "A new Stockholm studio engineering industrial-grade digital solutions — and partnering with founders to turn good ideas into great ventures.",
      cta1: "What we do",
      cta2: "Start a conversation",
      scroll: "Scroll",
    },
    dual: {
      heading: ["Two disciplines.", "Equal obsession."],
      subtitle: "NOWI operates at the intersection of building world-class technology and backing the founders who use it.",
      solutions: { kicker: "01 — Industrial Solutions", title: "We build.", desc: "Enterprise-grade digital products across fintech, AI automation, telecom, aviation and immersive technology — engineered for scale, speed and resilience.", tags: ["Fintech", "AI Automation", "Telecom", "Aviation", "Immersive"], cta: "Explore solutions" },
      ventures: { kicker: "02 — Venture Building", title: "We invest.", desc: "Together we turn good ideas into great ventures. We partner with founders through sweat equity — bringing strategy, design, tech and growth to build what matters.", tags: ["Sweat Equity", "Product Design", "Growth", "Co-founding", "Scale"], cta: "See our approach" },
    },
    services: {
      kicker: "Industrial-Leading Solutions",
      heading: ["Designed for the demands", "of your industry."],
      subtitle: "We combine engineering and imagination to craft solutions that fuel better experiences, higher conversions and stronger bonds — at scale.",
      items: [
        { title: "Fintech", desc: "Intelligent, revenue-driven financial ecosystems — beyond transactions." },
        { title: "AI Automation", desc: "Agentic workflows that adapt, speak, learn and scale." },
        { title: "Telecom", desc: "Helping telcos evolve from infrastructure providers into techcos." },
        { title: "Aviation", desc: "Air travel reimagined as a connected, data-driven journey." },
        { title: "Immersive & Loyalty", desc: "Sensory-driven ecosystems and loyalty engines that feel like experiences." },
        { title: "Product & Platform", desc: "Core modernisation to next-gen experiences, engineered end-to-end." },
      ],
      stats: ["Founded in Stockholm", "Ways we partner", "Average first reply", "Founder-led delivery"],
    },
    business: {
      kicker: "For small & local businesses",
      heading: ["Big-studio craft.", "Small-business budget."],
      subtitle: "Every local business deserves a website that wins customers. We help shops, studios and services across Europe launch something beautiful and fast — no jargon, no agency price tag.",
      includedTitle: "What you get",
      included: [
        "A custom website — designed for you, not a template",
        "Mobile-first and lightning fast",
        "Google-ready with local SEO basics",
        "Bookings, contact and enquiries built in",
        "Launched in about two weeks",
        "One clear, fixed price — no surprises",
      ],
      cta: "Get your business online",
      featuredLabel: "Live client · our first delivery",
      featuredName: "Bernedotter",
      featuredSector: "Garden care · Öland & Kalmar",
      featuredDesc: "A warm, personal brand and booking site for a one-person garden-care studio on Öland — clean, fast and effortless to run.",
      viewLive: "View live site",
    },
    marquee: ["Stockholm HQ", "Fintech", "AI Automation", "Small Business", "Websites", "Sweat Equity", "Venture Building", "Immersive"],
    ventures: {
      kicker: "Investment-Focused Venture Building",
      heading: ["Together we turn good", "ideas into great ventures."],
      chapters: [
        { title: "The Idea", desc: "We meet founders early. We pressure-test the vision, sharpen the strategy and validate the market — before a single line of code is written." },
        { title: "The Execution", desc: "Our team embeds with yours. We ship standout digital products fast, blending business strategy, design, tech and AI." },
        { title: "The Equity", desc: "We back what we build. Through sweat equity we become part of the venture — aligned, invested and committed to scaling it with you." },
      ],
      founding: {
        label: "Now onboarding · 2026",
        heading: "Be one of our first ventures",
        desc: "We're a brand-new studio, and we're choosing a small founding cohort of founders to build with — deeply, and for equity. If you're early and ambitious, there's room at the table.",
        cta: "Pitch us your idea",
      },
    },
    about: {
      kicker: "About — Stockholm, Sweden",
      heading: ["Nordic craft.", "European ambition."],
      p1: "NOWI is a young Stockholm studio and venture partner built for the way business works in 2026. We're small, hands-on and founder-led — and we treat every project like it's our own.",
      p2: "Whether we're shipping a local shop's website or co-building a startup, the standard is the same: create the best possible conditions for good ideas to succeed and grow.",
      stats: [["EU", "Built for Europe"], ["2026", "Founded in Stockholm"], ["∞", "Ideas welcome"]],
      localeImage: IMG.stockholmHq,
      localeCaption: "59.33°N · 18.06°E — HQ",
    },
    contact: {
      kicker: "Contact — Let's talk",
      heading: ["Pitch us your venture", "or get your business online."],
      name: "Your name", email: "Email", company: "Company (optional)",
      interestLabel: "I'm interested in",
      interests: ["A website for my business", "Venture / Investment", "Digital solutions", "Something else"],
      message: "Tell us about your business or idea",
      send: "Send message", sending: "Sending",
      igLine: "Prefer a live chat? DM us on WhatsApp — we reply fast.",
      igLabel: "Instagram DM", emailLabel: "Email", studioLabel: "Studio", studioValue: "Stockholm, Sweden",
      toastSuccess: "Message received. We'll be in touch shortly.",
      toastError: "Something went wrong. Please try again or message us on WhatsApp.",
      toastValidation: "Please fill in your name, email and message.",
    },
    footer: {
      tagline: "We build. We invest. From Stockholm, for Europe.",
      exploreLabel: "Explore", connectLabel: "Connect", startProject: "Start a project",
      rights: "© 2026 NOWI — All rights reserved",
    },
    consult: { kicker: "Free consultation", heading: ["Book a free", "15-minute call."], subtitle: "No pressure, no jargon — just 15 minutes to talk through your website, product or venture idea and see if we're a fit." },
    legal: { footerLink: "Legal / Imprint", title: "Legal Notice", intro: "Company information and imprint in accordance with applicable Swedish and EU law.", company: "Company", org: "Registration no.", vat: "VAT no.", office: "Registered office", contact: "Contact", responsible: "Responsible for content", back: "Back to home", disclaimer: "NOWI is the brand name of NOWI Skills AB. All content on this site is provided for general information and may change without notice." },
  },

  sv: {
    langLabel: "SV",
    nav: { solutions: "Lösningar", services: "Tjänster", business: "För företag", ventures: "Satsningar", about: "Om oss", contact: "Kontakt", letsTalk: "Kontakta oss", smallBusiness: "Småföretag" },
    hero: {
      badge: "Hej Sverige — Från Stockholm till hela Europa",
      line1: "Vi bygger.",
      line2: "Vi investerar.",
      subtitle: "En ny Stockholmsstudio som utvecklar industriella digitala lösningar — och samarbetar med grundare för att förvandla goda idéer till fantastiska bolag.",
      cta1: "Vad vi gör",
      cta2: "Starta en dialog",
      scroll: "Skrolla",
    },
    dual: {
      heading: ["Två discipliner.", "Samma passion."],
      subtitle: "NOWI verkar i skärningspunkten mellan att bygga teknik i världsklass och att stötta grundarna som använder den.",
      solutions: { kicker: "01 — Industriella lösningar", title: "Vi bygger.", desc: "Digitala produkter i företagsklass inom fintech, AI-automation, telekom, flyg och immersiv teknik — byggda för skala, hastighet och motståndskraft.", tags: ["Fintech", "AI-automation", "Telekom", "Flyg", "Immersiv"], cta: "Utforska lösningar" },
      ventures: { kicker: "02 — Bolagsbygge", title: "Vi investerar.", desc: "Tillsammans förvandlar vi goda idéer till fantastiska bolag. Vi samarbetar med grundare genom sweat equity — och bidrar med strategi, design, teknik och tillväxt för att bygga det som betyder något.", tags: ["Sweat Equity", "Produktdesign", "Tillväxt", "Medgrundare", "Skala"], cta: "Se vårt arbetssätt" },
    },
    services: {
      kicker: "Branschledande lösningar",
      heading: ["Skapade för kraven", "i din bransch."],
      subtitle: "Vi kombinerar ingenjörskonst och fantasi för att skapa lösningar som ger bättre upplevelser, högre konvertering och starkare relationer — i stor skala.",
      items: [
        { title: "Fintech", desc: "Intelligenta, intäktsdrivna finansiella ekosystem — bortom transaktioner." },
        { title: "AI-automation", desc: "Agentiska arbetsflöden som anpassar sig, talar, lär och skalar." },
        { title: "Telekom", desc: "Vi hjälper telekombolag att gå från infrastrukturleverantörer till techbolag." },
        { title: "Flyg", desc: "Flygresan omtänkt som en uppkopplad, datadriven resa." },
        { title: "Immersiv & Lojalitet", desc: "Sinnesdrivna ekosystem och lojalitetsmotorer som känns som upplevelser." },
        { title: "Produkt & Plattform", desc: "Från modernisering av kärnsystem till nästa generations upplevelser, byggt hela vägen." },
      ],
      stats: ["Grundat i Stockholm", "Sätt vi samarbetar", "Genomsnittligt första svar", "Grundarledd leverans"],
    },
    business: {
      kicker: "För små och lokala företag",
      heading: ["Hantverk i toppklass.", "Pris för småföretag."],
      subtitle: "Varje lokalt företag förtjänar en webbplats som vinner kunder. Vi hjälper butiker, studior och tjänster i hela Europa att lansera något vackert och snabbt — utan krångel och utan byråpris.",
      includedTitle: "Det här får du",
      included: [
        "En skräddarsydd webbplats — designad för dig, inte en mall",
        "Mobil först och blixtsnabb",
        "Google-redo med lokal SEO",
        "Bokning, kontakt och förfrågningar inbyggt",
        "Lanserad på cirka två veckor",
        "Ett tydligt, fast pris — inga överraskningar",
      ],
      cta: "Ta ditt företag online",
      featuredLabel: "Live-kund · vår första leverans",
      featuredName: "Bernedotter",
      featuredSector: "Trädgårdsskötsel · Öland & Kalmar",
      featuredDesc: "En varm, personlig varumärkes- och bokningssajt för en trädgårdsmästare på Öland — ren, snabb och enkel att sköta.",
      viewLive: "Besök sajten",
    },
    marquee: ["Stockholm HQ", "Fintech", "AI-automation", "Småföretag", "Webbplatser", "Sweat Equity", "Bolagsbygge", "Immersiv"],
    ventures: {
      kicker: "Investeringsfokuserat bolagsbygge",
      heading: ["Tillsammans förvandlar vi", "goda idéer till fantastiska bolag."],
      chapters: [
        { title: "Idén", desc: "Vi möter grundare tidigt. Vi utmanar visionen, skärper strategin och validerar marknaden — innan en enda kodrad skrivs." },
        { title: "Genomförandet", desc: "Vårt team arbetar sida vid sida med dig. Vi levererar enastående digitala produkter snabbt och blandar affärsstrategi, design, teknik och AI." },
        { title: "Ägandet", desc: "Vi står bakom det vi bygger. Genom sweat equity blir vi en del av bolaget — engagerade, investerade och fast beslutna att skala det med dig." },
      ],
      founding: {
        label: "Tar in nu · 2026",
        heading: "Bli ett av våra första bolag",
        desc: "Vi är en helt ny studio och väljer just nu ut en liten grupp grundare att bygga tillsammans med — på djupet och mot ägarandel. Är du tidig och ambitiös finns det plats vid bordet.",
        cta: "Pitcha din idé",
      },
    },
    about: {
      kicker: "Om oss — Stockholm, Sverige",
      heading: ["Nordiskt hantverk.", "Europeisk ambition."],
      p1: "NOWI är en ung Stockholmsstudio och bolagspartner byggd för hur affärer fungerar 2026. Vi är små, handfasta och grundarledda — och behandlar varje projekt som vårt eget.",
      p2: "Oavsett om vi levererar en lokal butiks webbplats eller bygger ett startupbolag är kravet detsamma: skapa bästa möjliga förutsättningar för goda idéer att lyckas och växa.",
      stats: [["EU", "Byggt för Europa"], ["2026", "Grundat i Stockholm"], ["∞", "Idéer välkomna"]],
      localeImage: IMG.stockholmOld,
      localeCaption: "Stockholm — Gamla Stan",
    },
    contact: {
      kicker: "Kontakt — Låt oss prata",
      heading: ["Pitcha ditt bolag", "eller ta ditt företag online."],
      name: "Ditt namn", email: "E-post", company: "Företag (valfritt)",
      interestLabel: "Jag är intresserad av",
      interests: ["En webbplats till mitt företag", "Bolag / Investering", "Digitala lösningar", "Något annat"],
      message: "Berätta om ditt företag eller din idé",
      send: "Skicka meddelande", sending: "Skickar",
      igLine: "Föredrar du att chatta live? Skriv till oss på WhatsApp — vi svarar snabbt.",
      igLabel: "Instagram-DM", emailLabel: "E-post", studioLabel: "Studio", studioValue: "Stockholm, Sverige",
      toastSuccess: "Meddelandet är mottaget. Vi hör av oss snart.",
      toastError: "Något gick fel. Försök igen eller skriv till oss på WhatsApp.",
      toastValidation: "Fyll i namn, e-post och meddelande.",
    },
    footer: {
      tagline: "Vi bygger. Vi investerar. Från Stockholm, för Europa.",
      exploreLabel: "Utforska", connectLabel: "Kontakt", startProject: "Starta ett projekt",
      rights: "© 2026 NOWI — Alla rättigheter förbehållna",
    },
    consult: { kicker: "Kostnadsfri konsultation", heading: ["Boka ett kostnadsfritt", "15-minuterssamtal."], subtitle: "Inget tryck, inget krångel — bara 15 minuter för att prata om din webbplats, produkt eller affärsidé och se om vi passar ihop." },
    legal: { footerLink: "Juridisk information", title: "Juridisk information", intro: "Företagsinformation enligt gällande svensk och EU-rätt.", company: "Företag", org: "Organisationsnr", vat: "Momsreg.nr", office: "Säte", contact: "Kontakt", responsible: "Ansvarig utgivare", back: "Tillbaka till startsidan", disclaimer: "NOWI är varumärkesnamnet för NOWI Skills AB. Innehållet på denna webbplats är endast avsett som allmän information och kan ändras utan föregående meddelande." },
  },

  da: {
    langLabel: "DA",
    nav: { solutions: "Løsninger", services: "Tjenester", business: "For virksomheder", ventures: "Satsninger", about: "Om os", contact: "Kontakt", letsTalk: "Kontakt os" },
    hero: {
      badge: "Hej Danmark — Fra Stockholm til hele Europa",
      line1: "Vi bygger.",
      line2: "Vi investerer.",
      subtitle: "Et nyt Stockholm-studie, der udvikler industrielle digitale løsninger — og samarbejder med iværksættere om at gøre gode idéer til fantastiske virksomheder.",
      cta1: "Hvad vi laver",
      cta2: "Start en samtale",
      scroll: "Scroll",
    },
    dual: {
      heading: ["To discipliner.", "Samme passion."],
      subtitle: "NOWI arbejder i krydsfeltet mellem at bygge teknologi i verdensklasse og at støtte de iværksættere, der bruger den.",
      solutions: { kicker: "01 — Industrielle løsninger", title: "Vi bygger.", desc: "Digitale produkter i virksomhedsklasse inden for fintech, AI-automatisering, telekom, luftfart og immersiv teknologi — bygget til skala, hastighed og robusthed.", tags: ["Fintech", "AI-automatisering", "Telekom", "Luftfart", "Immersiv"], cta: "Udforsk løsninger" },
      ventures: { kicker: "02 — Virksomhedsopbygning", title: "Vi investerer.", desc: "Sammen forvandler vi gode idéer til fantastiske virksomheder. Vi samarbejder med iværksættere gennem sweat equity — og bidrager med strategi, design, teknologi og vækst til at bygge det, der betyder noget.", tags: ["Sweat Equity", "Produktdesign", "Vækst", "Medstifter", "Skala"], cta: "Se vores tilgang" },
    },
    services: {
      kicker: "Brancheførende løsninger",
      heading: ["Skabt til kravene", "i din branche."],
      subtitle: "Vi kombinerer ingeniørkunst og fantasi for at skabe løsninger, der giver bedre oplevelser, højere konvertering og stærkere relationer — i stor skala.",
      items: [
        { title: "Fintech", desc: "Intelligente, indtægtsdrevne finansielle økosystemer — ud over transaktioner." },
        { title: "AI-automatisering", desc: "Agentiske arbejdsgange, der tilpasser sig, taler, lærer og skalerer." },
        { title: "Telekom", desc: "Vi hjælper teleselskaber med at gå fra infrastrukturudbydere til techselskaber." },
        { title: "Luftfart", desc: "Flyrejsen gentænkt som en forbundet, datadrevet rejse." },
        { title: "Immersiv & Loyalitet", desc: "Sansedrevne økosystemer og loyalitetsmotorer, der føles som oplevelser." },
        { title: "Produkt & Platform", desc: "Fra modernisering af kernesystemer til næste generations oplevelser, bygget hele vejen." },
      ],
      stats: ["Grundlagt i Stockholm", "Måder vi samarbejder på", "Gennemsnitligt første svar", "Stifterledet levering"],
    },
    business: {
      kicker: "For små og lokale virksomheder",
      heading: ["Håndværk i topklasse.", "Pris for små virksomheder."],
      subtitle: "Enhver lokal virksomhed fortjener en hjemmeside, der vinder kunder. Vi hjælper butikker, studier og services i hele Europa med at lancere noget smukt og hurtigt — uden jargon og uden bureaupris.",
      includedTitle: "Det får du",
      included: [
        "En skræddersyet hjemmeside — designet til dig, ikke en skabelon",
        "Mobil-først og lynhurtig",
        "Google-klar med lokal SEO",
        "Booking, kontakt og forespørgsler indbygget",
        "Lanceret på cirka to uger",
        "Én klar, fast pris — ingen overraskelser",
      ],
      cta: "Få din virksomhed online",
      featuredLabel: "Live-kunde · vores første levering",
      featuredName: "Bernedotter",
      featuredSector: "Havepleje · Öland & Kalmar",
      featuredDesc: "Et varmt, personligt brand- og bookingsite for en havemester på Öland — rent, hurtigt og nemt at drive.",
      viewLive: "Besøg siden",
    },
    marquee: ["Stockholm HQ", "Fintech", "AI-automatisering", "Små virksomheder", "Hjemmesider", "Sweat Equity", "Virksomhedsopbygning", "Immersiv"],
    ventures: {
      kicker: "Investeringsfokuseret virksomhedsopbygning",
      heading: ["Sammen forvandler vi gode", "idéer til fantastiske virksomheder."],
      chapters: [
        { title: "Idéen", desc: "Vi møder iværksættere tidligt. Vi udfordrer visionen, skærper strategien og validerer markedet — før en eneste linje kode skrives." },
        { title: "Udførelsen", desc: "Vores team arbejder side om side med dig. Vi leverer enestående digitale produkter hurtigt og blander forretningsstrategi, design, teknologi og AI." },
        { title: "Ejerskabet", desc: "Vi står bag det, vi bygger. Gennem sweat equity bliver vi en del af virksomheden — engagerede, investerede og fast besluttede på at skalere den med dig." },
      ],
      founding: {
        label: "Optager nu · 2026",
        heading: "Bliv en af vores første virksomheder",
        desc: "Vi er et helt nyt studie og udvælger netop nu en lille gruppe iværksættere at bygge sammen med — i dybden og mod ejerandel. Er du tidlig og ambitiøs, er der plads ved bordet.",
        cta: "Pitch din idé",
      },
    },
    about: {
      kicker: "Om os — Stockholm, Sverige",
      heading: ["Nordisk håndværk.", "Europæisk ambition."],
      p1: "NOWI er et ungt Stockholm-studie og en virksomhedspartner bygget til den måde, forretning fungerer på i 2026. Vi er små, praktiske og stifterledede — og behandler hvert projekt, som var det vores eget.",
      p2: "Uanset om vi leverer en lokal butiks hjemmeside eller bygger en startup, er standarden den samme: skabe de bedst mulige betingelser for, at gode idéer kan lykkes og vokse.",
      stats: [["EU", "Bygget til Europa"], ["2026", "Grundlagt i Stockholm"], ["∞", "Idéer velkomne"]],
      localeImage: IMG.copenhagen,
      localeCaption: "København — Nyhavn",
    },
    contact: {
      kicker: "Kontakt — Lad os tale",
      heading: ["Pitch din virksomhed", "eller få den online."],
      name: "Dit navn", email: "E-mail", company: "Virksomhed (valgfrit)",
      interestLabel: "Jeg er interesseret i",
      interests: ["En hjemmeside til min virksomhed", "Virksomhed / Investering", "Digitale løsninger", "Noget andet"],
      message: "Fortæl os om din virksomhed eller idé",
      send: "Send besked", sending: "Sender",
      igLine: "Foretrækker du en live-chat? Skriv til os på Instagram — vi svarer hurtigt.",
      igLabel: "Instagram-DM", emailLabel: "E-mail", studioLabel: "Studie", studioValue: "Stockholm, Sverige",
      toastSuccess: "Beskeden er modtaget. Vi vender tilbage snart.",
      toastError: "Noget gik galt. Prøv igen, eller skriv til os på WhatsApp.",
      toastValidation: "Udfyld navn, e-mail og besked.",
    },
    footer: {
      tagline: "Vi bygger. Vi investerer. Fra Stockholm, for Europa.",
      exploreLabel: "Udforsk", connectLabel: "Kontakt", startProject: "Start et projekt",
      rights: "© 2026 NOWI — Alle rettigheder forbeholdes",
    },
    consult: { kicker: "Gratis konsultation", heading: ["Book et gratis", "15-minutters møde."], subtitle: "Ingen pres, ingen jargon — bare 15 minutter til at tale om din hjemmeside, dit produkt eller din idé og se, om vi passer sammen." },
    legal: { footerLink: "Juridisk information", title: "Juridisk information", intro: "Virksomhedsoplysninger i henhold til gældende svensk og EU-ret.", company: "Virksomhed", org: "Registreringsnr.", vat: "Momsnr.", office: "Hjemsted", contact: "Kontakt", responsible: "Ansvarlig for indhold", back: "Tilbage til forsiden", disclaimer: "NOWI er varemærkenavnet for NOWI Skills AB. Indholdet på dette websted er kun til generel information og kan ændres uden varsel." },
  },

  nb: {
    langLabel: "NO",
    nav: { solutions: "Løsninger", services: "Tjenester", business: "For bedrifter", ventures: "Satsinger", about: "Om oss", contact: "Kontakt", letsTalk: "Kontakt oss", smallBusiness: "Småbedrifter" },
    hero: {
      badge: "Hei Norge — Fra Stockholm til hele Europa",
      line1: "Vi bygger.",
      line2: "Vi investerer.",
      subtitle: "Et nytt Stockholm-studio som utvikler industrielle digitale løsninger — og samarbeider med gründere for å gjøre gode idéer til fantastiske selskaper.",
      cta1: "Hva vi gjør",
      cta2: "Start en samtale",
      scroll: "Rull",
    },
    dual: {
      heading: ["To disipliner.", "Samme lidenskap."],
      subtitle: "NOWI opererer i skjæringspunktet mellom å bygge teknologi i verdensklasse og å støtte gründerne som bruker den.",
      solutions: { kicker: "01 — Industrielle løsninger", title: "Vi bygger.", desc: "Digitale produkter i bedriftsklasse innen fintech, AI-automatisering, telekom, luftfart og immersiv teknologi — bygget for skala, hastighet og robusthet.", tags: ["Fintech", "AI-automatisering", "Telekom", "Luftfart", "Immersiv"], cta: "Utforsk løsninger" },
      ventures: { kicker: "02 — Selskapsbygging", title: "Vi investerer.", desc: "Sammen gjør vi gode idéer til fantastiske selskaper. Vi samarbeider med gründere gjennom sweat equity — og bidrar med strategi, design, teknologi og vekst for å bygge det som betyr noe.", tags: ["Sweat Equity", "Produktdesign", "Vekst", "Medgründer", "Skala"], cta: "Se vår tilnærming" },
    },
    services: {
      kicker: "Bransjeledende løsninger",
      heading: ["Skapt for kravene", "i din bransje."],
      subtitle: "Vi kombinerer ingeniørkunst og fantasi for å skape løsninger som gir bedre opplevelser, høyere konvertering og sterkere relasjoner — i stor skala.",
      items: [
        { title: "Fintech", desc: "Intelligente, inntektsdrevne finansielle økosystemer — utover transaksjoner." },
        { title: "AI-automatisering", desc: "Agentiske arbeidsflyter som tilpasser seg, snakker, lærer og skalerer." },
        { title: "Telekom", desc: "Vi hjelper teleselskaper med å gå fra infrastrukturleverandører til techselskaper." },
        { title: "Luftfart", desc: "Flyreisen gjentenkt som en tilkoblet, datadrevet reise." },
        { title: "Immersiv & Lojalitet", desc: "Sansedrevne økosystemer og lojalitetsmotorer som føles som opplevelser." },
        { title: "Produkt & Plattform", desc: "Fra modernisering av kjernesystemer til neste generasjons opplevelser, bygget hele veien." },
      ],
      stats: ["Grunnlagt i Stockholm", "Måter vi samarbeider på", "Gjennomsnittlig første svar", "Gründerledet leveranse"],
    },
    business: {
      kicker: "For små og lokale bedrifter",
      heading: ["Håndverk i toppklasse.", "Pris for småbedrifter."],
      subtitle: "Enhver lokal bedrift fortjener en nettside som vinner kunder. Vi hjelper butikker, studioer og tjenester i hele Europa med å lansere noe vakkert og raskt — uten sjargong og uten byråpris.",
      includedTitle: "Dette får du",
      included: [
        "En skreddersydd nettside — designet for deg, ikke en mal",
        "Mobil-først og lynrask",
        "Google-klar med lokal SEO",
        "Booking, kontakt og henvendelser innebygd",
        "Lansert på omtrent to uker",
        "Én tydelig, fast pris — ingen overraskelser",
      ],
      cta: "Få bedriften din på nett",
      featuredLabel: "Live-kunde · vår første leveranse",
      featuredName: "Bernedotter",
      featuredSector: "Hagestell · Öland & Kalmar",
      featuredDesc: "Et varmt, personlig merkevare- og bookingnettsted for en gartner på Öland — rent, raskt og enkelt å drive.",
      viewLive: "Besøk siden",
    },
    marquee: ["Stockholm HQ", "Fintech", "AI-automatisering", "Småbedrifter", "Nettsider", "Sweat Equity", "Selskapsbygging", "Immersiv"],
    ventures: {
      kicker: "Investeringsfokusert selskapsbygging",
      heading: ["Sammen gjør vi gode idéer", "til fantastiske selskaper."],
      chapters: [
        { title: "Idéen", desc: "Vi møter gründere tidlig. Vi utfordrer visjonen, skjerper strategien og validerer markedet — før en eneste kodelinje skrives." },
        { title: "Gjennomføringen", desc: "Teamet vårt jobber side om side med deg. Vi leverer enestående digitale produkter raskt og kombinerer forretningsstrategi, design, teknologi og AI." },
        { title: "Eierskapet", desc: "Vi står bak det vi bygger. Gjennom sweat equity blir vi en del av selskapet — engasjerte, investerte og fast bestemt på å skalere det med deg." },
      ],
      founding: {
        label: "Tar inn nå · 2026",
        heading: "Bli ett av våre første selskaper",
        desc: "Vi er et helt nytt studio og velger nå ut en liten gruppe gründere å bygge sammen med — i dybden og mot eierandel. Er du tidlig og ambisiøs, er det plass ved bordet.",
        cta: "Pitch idéen din",
      },
    },
    about: {
      kicker: "Om oss — Stockholm, Sverige",
      heading: ["Nordisk håndverk.", "Europeisk ambisjon."],
      p1: "NOWI er et ungt Stockholm-studio og en selskapspartner bygget for slik forretning fungerer i 2026. Vi er små, praktiske og gründerledet — og behandler hvert prosjekt som om det var vårt eget.",
      p2: "Enten vi leverer nettsiden til en lokal butikk eller bygger et startupselskap, er standarden den samme: skape best mulige forutsetninger for at gode idéer skal lykkes og vokse.",
      stats: [["EU", "Bygget for Europa"], ["2026", "Grunnlagt i Stockholm"], ["∞", "Idéer velkomne"]],
      localeImage: IMG.oslo,
      localeCaption: "Oslo — Norge",
    },
    contact: {
      kicker: "Kontakt — La oss snakke",
      heading: ["Pitch selskapet ditt", "eller få bedriften på nett."],
      name: "Navnet ditt", email: "E-post", company: "Selskap (valgfritt)",
      interestLabel: "Jeg er interessert i",
      interests: ["En nettside til bedriften min", "Selskap / Investering", "Digitale løsninger", "Noe annet"],
      message: "Fortell oss om bedriften eller idéen din",
      send: "Send melding", sending: "Sender",
      igLine: "Foretrekker du en live-chat? Send oss en melding på WhatsApp — vi svarer raskt.",
      igLabel: "Instagram-DM", emailLabel: "E-post", studioLabel: "Studio", studioValue: "Stockholm, Sverige",
      toastSuccess: "Meldingen er mottatt. Vi tar kontakt snart.",
      toastError: "Noe gikk galt. Prøv igjen, eller send oss en melding på WhatsApp.",
      toastValidation: "Fyll inn navn, e-post og melding.",
    },
    footer: {
      tagline: "Vi bygger. Vi investerer. Fra Stockholm, for Europa.",
      exploreLabel: "Utforsk", connectLabel: "Kontakt", startProject: "Start et prosjekt",
      rights: "© 2026 NOWI — Alle rettigheter forbeholdt",
    },
    consult: { kicker: "Gratis konsultasjon", heading: ["Book en gratis", "15-minutters prat."], subtitle: "Ingen press, ingen sjargong — bare 15 minutter for å snakke om nettsiden, produktet eller idéen din og se om vi passer sammen." },
    legal: { footerLink: "Juridisk informasjon", title: "Juridisk informasjon", intro: "Selskapsinformasjon i henhold til gjeldende svensk og EU-rett.", company: "Selskap", org: "Org.nr", vat: "MVA-nr.", office: "Forretningsadresse", contact: "Kontakt", responsible: "Ansvarlig for innhold", back: "Tilbake til forsiden", disclaimer: "NOWI er varemerkenavnet til NOWI Skills AB. Innholdet på dette nettstedet er kun ment som generell informasjon og kan endres uten varsel." },
  },

  fi: {
    langLabel: "FI",
    nav: { solutions: "Ratkaisut", services: "Palvelut", business: "Yrityksille", ventures: "Sijoitukset", about: "Tietoa", contact: "Yhteystiedot", letsTalk: "Otetaan yhteyttä", smallBusiness: "Pienyritykset" },
    hero: {
      badge: "Hei Suomi — Tukholmasta koko Eurooppaan",
      line1: "Me rakennamme.",
      line2: "Me sijoitamme.",
      subtitle: "Uusi tukholmalainen studio, joka rakentaa teollisen tason digitaalisia ratkaisuja — ja kumppanoituu perustajien kanssa muuttaakseen hyvät ideat loistaviksi yrityksiksi.",
      cta1: "Mitä teemme",
      cta2: "Aloita keskustelu",
      scroll: "Vieritä",
    },
    dual: {
      heading: ["Kaksi osaamisaluetta.", "Sama intohimo."],
      subtitle: "NOWI toimii maailmanluokan teknologian rakentamisen ja sitä käyttävien perustajien tukemisen risteyksessä.",
      solutions: { kicker: "01 — Teolliset ratkaisut", title: "Me rakennamme.", desc: "Yritystason digitaaliset tuotteet fintechissä, tekoälyautomaatiossa, telekommunikaatiossa, ilmailussa ja immersiivisessä teknologiassa — rakennettu skaalaan, nopeuteen ja kestävyyteen.", tags: ["Fintech", "Tekoälyautomaatio", "Telekom", "Ilmailu", "Immersiivinen"], cta: "Tutustu ratkaisuihin" },
      ventures: { kicker: "02 — Yritysrakentaminen", title: "Me sijoitamme.", desc: "Yhdessä muutamme hyvät ideat loistaviksi yrityksiksi. Kumppanoidumme perustajien kanssa sweat equity -mallilla — tuoden strategian, muotoilun, teknologian ja kasvun.", tags: ["Sweat Equity", "Tuotemuotoilu", "Kasvu", "Yhteisperustaja", "Skaalaus"], cta: "Katso toimintatapamme" },
    },
    services: {
      kicker: "Alan johtavat ratkaisut",
      heading: ["Suunniteltu alasi", "vaatimuksiin."],
      subtitle: "Yhdistämme insinööritaidon ja mielikuvituksen luodaksemme ratkaisuja, jotka tuottavat parempia kokemuksia, korkeampaa konversiota ja vahvempia suhteita — suuressa mittakaavassa.",
      items: [
        { title: "Fintech", desc: "Älykkäät, tuottopohjaiset rahoitusekosysteemit — transaktioiden tuolla puolen." },
        { title: "Tekoälyautomaatio", desc: "Agenttipohjaiset työnkulut, jotka mukautuvat, puhuvat, oppivat ja skaalautuvat." },
        { title: "Telekom", desc: "Autamme teleoperaattoreita kehittymään infrastruktuurin tarjoajista teknologiayhtiöiksi." },
        { title: "Ilmailu", desc: "Lentomatkustaminen uudelleen ajateltuna yhdistettynä, dataohjattuna matkana." },
        { title: "Immersiivinen & Lojaliteetti", desc: "Aistipohjaiset ekosysteemit ja lojaliteettimoottorit, jotka tuntuvat elämyksiltä." },
        { title: "Tuote & Alusta", desc: "Ydinjärjestelmien modernisoinnista seuraavan sukupolven kokemuksiin, rakennettu alusta loppuun." },
      ],
      stats: ["Perustettu Tukholmassa", "Tapoja tehdä yhteistyötä", "Keskim. ensimmäinen vastaus", "Perustajavetoinen toteutus"],
    },
    business: {
      kicker: "Pienille ja paikallisille yrityksille",
      heading: ["Huippustudion käsityötä.", "Pienyrityksen budjetilla."],
      subtitle: "Jokainen paikallinen yritys ansaitsee verkkosivun, joka voittaa asiakkaita. Autamme kauppoja, studioita ja palveluita eri puolilla Eurooppaa julkaisemaan jotain kaunista ja nopeaa — ilman jargonia ja ilman toimistohintaa.",
      includedTitle: "Mitä saat",
      included: [
        "Räätälöity verkkosivu — suunniteltu sinulle, ei mallipohja",
        "Mobiili edellä ja salamannopea",
        "Google-valmis paikallisella hakukoneoptimoinnilla",
        "Varaukset, yhteydenotot ja tiedustelut sisäänrakennettu",
        "Julkaistu noin kahdessa viikossa",
        "Yksi selkeä, kiinteä hinta — ei yllätyksiä",
      ],
      cta: "Vie yrityksesi verkkoon",
      featuredLabel: "Live-asiakas · ensimmäinen toimituksemme",
      featuredName: "Bernedotter",
      featuredSector: "Puutarhanhoito · Öölanti & Kalmar",
      featuredDesc: "Lämmin, henkilökohtainen brändi- ja varaussivusto yhden hengen puutarhastudiolle Öölannissa — selkeä, nopea ja vaivaton ylläpitää.",
      viewLive: "Katso sivusto",
    },
    marquee: ["Stockholm HQ", "Fintech", "Tekoälyautomaatio", "Pienyritykset", "Verkkosivut", "Sweat Equity", "Yritysrakentaminen", "Immersiivinen"],
    ventures: {
      kicker: "Sijoituspainotteinen yritysrakentaminen",
      heading: ["Yhdessä muutamme hyvät", "ideat loistaviksi yrityksiksi."],
      chapters: [
        { title: "Idea", desc: "Tapaamme perustajat varhain. Testaamme vision, terävöitämme strategian ja validoimme markkinan — ennen kuin riviäkään koodia kirjoitetaan." },
        { title: "Toteutus", desc: "Tiimimme työskentelee rinnallasi. Toimitamme erottuvia digituotteita nopeasti yhdistäen liiketoimintastrategian, muotoilun, teknologian ja tekoälyn." },
        { title: "Omistus", desc: "Seisomme rakentamamme takana. Sweat equityn kautta meistä tulee osa yritystä — sitoutuneina ja mukana skaalaamassa sitä kanssasi." },
      ],
      founding: {
        label: "Otamme mukaan nyt · 2026",
        heading: "Ole yksi ensimmäisistä yrityksistämme",
        desc: "Olemme aivan uusi studio ja valitsemme pienen perustajajoukon, jonka kanssa rakennamme — syvällisesti ja omistusosuutta vastaan. Jos olet varhaisessa vaiheessa ja kunnianhimoinen, pöydässä on tilaa.",
        cta: "Kerro ideasi",
      },
    },
    about: {
      kicker: "Tietoa — Tukholma, Ruotsi",
      heading: ["Pohjoismaista käsityötä.", "Eurooppalaista kunnianhimoa."],
      p1: "NOWI on nuori tukholmalainen studio ja yrityskumppani, joka on rakennettu vuoden 2026 liiketoiminnalle. Olemme pieniä, käytännönläheisiä ja perustajavetoisia — ja kohtelemme jokaista projektia kuin omaamme.",
      p2: "Toimitammepa paikallisen kaupan verkkosivun tai rakennamme startupin, vaatimus on sama: luoda parhaat mahdolliset edellytykset hyvien ideoiden menestyä ja kasvaa.",
      stats: [["EU", "Rakennettu Euroopalle"], ["2026", "Perustettu Tukholmassa"], ["∞", "Ideat tervetulleita"]],
      localeImage: "https://images.pexels.com/photos/3581820/pexels-photo-3581820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      localeCaption: "Helsinki — Suomi",
    },
    contact: {
      kicker: "Yhteystiedot — Jutellaan",
      heading: ["Pitchaa yrityksesi", "tai vie yrityksesi verkkoon."],
      name: "Nimesi", email: "Sähköposti", company: "Yritys (valinnainen)",
      interestLabel: "Olen kiinnostunut",
      interests: ["Verkkosivu yritykselleni", "Yritys / Sijoitus", "Digitaaliset ratkaisut", "Jokin muu"],
      message: "Kerro yrityksestäsi tai ideastasi",
      send: "Lähetä viesti", sending: "Lähetetään",
      igLine: "Haluatko chatata livenä? Lähetä meille viesti WhatsAppissa — vastaamme nopeasti.",
      igLabel: "Instagram-DM", emailLabel: "Sähköposti", studioLabel: "Studio", studioValue: "Tukholma, Ruotsi",
      toastSuccess: "Viesti vastaanotettu. Olemme pian yhteydessä.",
      toastError: "Jokin meni pieleen. Yritä uudelleen tai lähetä meille viesti WhatsAppissa.",
      toastValidation: "Täytä nimi, sähköposti ja viesti.",
    },
    footer: {
      tagline: "Me rakennamme. Me sijoitamme. Tukholmasta, Euroopalle.",
      exploreLabel: "Tutustu", connectLabel: "Yhteys", startProject: "Aloita projekti",
      rights: "© 2026 NOWI — Kaikki oikeudet pidätetään",
    },
    consult: { kicker: "Ilmainen konsultaatio", heading: ["Varaa maksuton", "15 minuutin puhelu."], subtitle: "Ei painostusta, ei jargonia — vain 15 minuuttia keskustellaksemme verkkosivustostasi, tuotteestasi tai ideastasi ja nähdäksemme sopimmeko yhteen." },
    legal: { footerLink: "Oikeudelliset tiedot", title: "Oikeudelliset tiedot", intro: "Yritystiedot sovellettavan Ruotsin ja EU:n lainsäädännön mukaisesti.", company: "Yritys", org: "Rekisterinumero", vat: "ALV-numero", office: "Kotipaikka", contact: "Yhteystiedot", responsible: "Sisällöstä vastaava", back: "Takaisin etusivulle", disclaimer: "NOWI on NOWI Skills AB:n tuotemerkki. Tämän sivuston sisältö on tarkoitettu vain yleiseksi tiedoksi ja voi muuttua ilman erillistä ilmoitusta." },
  },

  is: {
    langLabel: "IS",
    nav: { solutions: "Lausnir", services: "Þjónusta", business: "Fyrir fyrirtæki", ventures: "Fjárfestingar", about: "Um okkur", contact: "Hafðu samband", letsTalk: "Hafðu samband", smallBusiness: "Lítil fyrirtæki" },
    hero: {
      badge: "Halló Ísland — Frá Stokkhólmi til allrar Evrópu",
      line1: "Við byggjum.",
      line2: "Við fjárfestum.",
      subtitle: "Nýtt stúdíó í Stokkhólmi sem smíðar stafrænar lausnir í iðnaðargæðum — og vinnur með frumkvöðlum að því að breyta góðum hugmyndum í frábær fyrirtæki.",
      cta1: "Hvað við gerum",
      cta2: "Byrja samtal",
      scroll: "Skruna",
    },
    dual: {
      heading: ["Tvær greinar.", "Sama ástríða."],
      subtitle: "NOWI starfar á mótum þess að byggja tækni í heimsklassa og að styðja frumkvöðlana sem nota hana.",
      solutions: { kicker: "01 — Iðnaðarlausnir", title: "Við byggjum.", desc: "Stafrænar vörur í fyrirtækjagæðum í fintech, gervigreindarsjálfvirkni, fjarskiptum, flugi og yfirgripsmikilli tækni — smíðaðar fyrir umfang, hraða og seiglu.", tags: ["Fintech", "Gervigreind", "Fjarskipti", "Flug", "Yfirgripsmikið"], cta: "Kanna lausnir" },
      ventures: { kicker: "02 — Fyrirtækjauppbygging", title: "Við fjárfestum.", desc: "Saman breytum við góðum hugmyndum í frábær fyrirtæki. Við vinnum með frumkvöðlum í gegnum sweat equity — með stefnu, hönnun, tækni og vöxt.", tags: ["Sweat Equity", "Vöruhönnun", "Vöxtur", "Meðstofnandi", "Skölun"], cta: "Sjá aðferð okkar" },
    },
    services: {
      kicker: "Leiðandi iðnaðarlausnir",
      heading: ["Hannað fyrir kröfur", "þinnar atvinnugreinar."],
      subtitle: "Við sameinum verkfræði og hugmyndaflug til að skapa lausnir sem knýja betri upplifun, hærri viðskiptahlutfall og sterkari tengsl — í stórum skala.",
      items: [
        { title: "Fintech", desc: "Snjöll, tekjudrifin fjármálavistkerfi — handan færslna." },
        { title: "Gervigreind", desc: "Sjálfvirk vinnuflæði sem aðlagast, tala, læra og skala." },
        { title: "Fjarskipti", desc: "Við hjálpum fjarskiptafyrirtækjum að þróast úr innviðaveitendum í tæknifyrirtæki." },
        { title: "Flug", desc: "Flugferðir endurhugsaðar sem tengd, gagnadrifin ferð." },
        { title: "Yfirgripsmikið & Tryggð", desc: "Skynjunardrifin vistkerfi og tryggðarkerfi sem líkjast upplifunum." },
        { title: "Vara & Vettvangur", desc: "Frá nútímavæðingu kjarnakerfa til næstu kynslóðar upplifana, smíðað frá enda til enda." },
      ],
      stats: ["Stofnað í Stokkhólmi", "Leiðir til samstarfs", "Meðal fyrsta svar", "Afhending stýrð af stofnendum"],
    },
    business: {
      kicker: "Fyrir lítil og staðbundin fyrirtæki",
      heading: ["Handverk í hæsta gæðaflokki.", "Á verði fyrir lítil fyrirtæki."],
      subtitle: "Sérhvert staðbundið fyrirtæki á skilið vefsíðu sem laðar að viðskiptavini. Við hjálpum verslunum, stúdíóum og þjónustum um alla Evrópu að setja í loftið eitthvað fallegt og hratt — án hrognamáls og án stofuverðs.",
      includedTitle: "Það sem þú færð",
      included: [
        "Sérsniðin vefsíða — hönnuð fyrir þig, ekki sniðmát",
        "Farsíma-fyrst og eldsnögg",
        "Google-tilbúin með staðbundinni leitarvélabestun",
        "Bókanir, samband og fyrirspurnir innbyggðar",
        "Sett í loftið á um það bil tveimur vikum",
        "Eitt skýrt, fast verð — engar óvæntar uppákomur",
      ],
      cta: "Komdu fyrirtækinu þínu á netið",
      featuredLabel: "Lifandi viðskiptavinur · fyrsta afhending okkar",
      featuredName: "Bernedotter",
      featuredSector: "Garðumhirða · Öland & Kalmar",
      featuredDesc: "Hlýleg, persónuleg vörumerkja- og bókunarsíða fyrir eins manns garðstúdíó á Öland — hrein, hröð og áreynslulaus í rekstri.",
      viewLive: "Skoða síðuna",
    },
    marquee: ["Stockholm HQ", "Fintech", "Gervigreind", "Lítil fyrirtæki", "Vefsíður", "Sweat Equity", "Fyrirtækjauppbygging", "Yfirgripsmikið"],
    ventures: {
      kicker: "Fjárfestingamiðuð fyrirtækjauppbygging",
      heading: ["Saman breytum við góðum", "hugmyndum í frábær fyrirtæki."],
      chapters: [
        { title: "Hugmyndin", desc: "Við hittum frumkvöðla snemma. Við prófum sýnina, skerpum stefnuna og staðfestum markaðinn — áður en ein einasta kóðalína er skrifuð." },
        { title: "Framkvæmdin", desc: "Teymið okkar vinnur við hlið þér. Við afhendum framúrskarandi stafrænar vörur hratt og sameinum viðskiptastefnu, hönnun, tækni og gervigreind." },
        { title: "Eignarhaldið", desc: "Við stöndum á bak við það sem við byggjum. Í gegnum sweat equity verðum við hluti af fyrirtækinu — samstillt og staðráðin í að skala það með þér." },
      ],
      founding: {
        label: "Tökum inn núna · 2026",
        heading: "Vertu eitt af okkar fyrstu fyrirtækjum",
        desc: "Við erum splunkunýtt stúdíó og veljum lítinn hóp frumkvöðla til að byggja með — djúpt og gegn eignarhlut. Ef þú ert snemma á ferðinni og metnaðarfull/ur er pláss við borðið.",
        cta: "Kynntu hugmyndina þína",
      },
    },
    about: {
      kicker: "Um okkur — Stokkhólmi, Svíþjóð",
      heading: ["Norrænt handverk.", "Evrópskur metnaður."],
      p1: "NOWI er ungt stúdíó í Stokkhólmi og fyrirtækjafélagi byggt fyrir það hvernig viðskipti virka árið 2026. Við erum lítil, praktísk og stofnendastýrð — og komum fram við hvert verkefni eins og okkar eigið.",
      p2: "Hvort sem við afhendum vefsíðu fyrir staðbundna verslun eða byggjum sprotafyrirtæki er kröfustaðallinn sá sami: að skapa bestu mögulegu skilyrði fyrir góðar hugmyndir til að ná árangri og vaxa.",
      stats: [["EU", "Byggt fyrir Evrópu"], ["2026", "Stofnað í Stokkhólmi"], ["∞", "Hugmyndir velkomnar"]],
      localeImage: "https://images.unsplash.com/photo-1608468716860-5566b7671ea3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
      localeCaption: "Reykjavík — Ísland",
    },
    contact: {
      kicker: "Hafðu samband — Tölum saman",
      heading: ["Kynntu fyrirtækið þitt", "eða komdu því á netið."],
      name: "Nafnið þitt", email: "Netfang", company: "Fyrirtæki (valfrjálst)",
      interestLabel: "Ég hef áhuga á",
      interests: ["Vefsíðu fyrir fyrirtækið mitt", "Fyrirtæki / Fjárfesting", "Stafrænar lausnir", "Eitthvað annað"],
      message: "Segðu okkur frá fyrirtækinu þínu eða hugmynd",
      send: "Senda skilaboð", sending: "Sendi",
      igLine: "Vilt þú spjalla í beinni? Sendu okkur skilaboð á WhatsApp — við svörum fljótt.",
      igLabel: "Instagram-DM", emailLabel: "Netfang", studioLabel: "Stúdíó", studioValue: "Stokkhólmi, Svíþjóð",
      toastSuccess: "Skilaboð móttekin. Við höfum samband fljótlega.",
      toastError: "Eitthvað fór úrskeiðis. Reyndu aftur eða sendu okkur skilaboð á WhatsApp.",
      toastValidation: "Fylltu út nafn, netfang og skilaboð.",
    },
    footer: {
      tagline: "Við byggjum. Við fjárfestum. Frá Stokkhólmi, fyrir Evrópu.",
      exploreLabel: "Kanna", connectLabel: "Tengsl", startProject: "Byrja verkefni",
      rights: "© 2026 NOWI — Allur réttur áskilinn",
    },
    consult: { kicker: "Ókeypis ráðgjöf", heading: ["Bókaðu ókeypis", "15 mínútna símtal."], subtitle: "Enginn þrýstingur, ekkert hrognamál — bara 15 mínútur til að ræða vefsíðuna, vöruna eða hugmyndina þína og sjá hvort við eigum samleið." },
    legal: { footerLink: "Lögfræðilegar upplýsingar", title: "Lögfræðilegar upplýsingar", intro: "Fyrirtækjaupplýsingar í samræmi við gildandi sænsk og evrópsk lög.", company: "Fyrirtæki", org: "Skráningarnr.", vat: "VSK-númer", office: "Skráð heimilisfang", contact: "Hafðu samband", responsible: "Ábyrgðaraðili efnis", back: "Til baka á forsíðu", disclaimer: "NOWI er vörumerki NOWI Skills AB. Efni á þessari vefsíðu er einungis til almennrar upplýsingar og getur breyst án fyrirvara." },
  },

  de: {
    langLabel: "DE",
    nav: { solutions: "Lösungen", services: "Leistungen", business: "Für Unternehmen", ventures: "Investitionen", about: "Über uns", contact: "Kontakt", letsTalk: "Kontakt", smallBusiness: "Kleine Unternehmen" },
    hero: {
      badge: "Hallo Deutschland — Von Stockholm für ganz Europa",
      line1: "Wir bauen.",
      line2: "Wir investieren.",
      subtitle: "Ein neues Stockholmer Studio, das digitale Lösungen auf Industrieniveau entwickelt — und mit Gründern zusammenarbeitet, um gute Ideen in großartige Unternehmen zu verwandeln.",
      cta1: "Was wir tun",
      cta2: "Gespräch beginnen",
      scroll: "Scrollen",
    },
    dual: {
      heading: ["Zwei Disziplinen.", "Dieselbe Leidenschaft."],
      subtitle: "NOWI agiert an der Schnittstelle zwischen dem Bau von Weltklasse-Technologie und der Unterstützung der Gründer, die sie nutzen.",
      solutions: { kicker: "01 — Industrielle Lösungen", title: "Wir bauen.", desc: "Digitale Produkte auf Unternehmensniveau in Fintech, KI-Automatisierung, Telekommunikation, Luftfahrt und immersiver Technologie — entwickelt für Skalierung, Geschwindigkeit und Resilienz.", tags: ["Fintech", "KI-Automatisierung", "Telekom", "Luftfahrt", "Immersiv"], cta: "Lösungen entdecken" },
      ventures: { kicker: "02 — Unternehmensaufbau", title: "Wir investieren.", desc: "Gemeinsam verwandeln wir gute Ideen in großartige Unternehmen. Wir arbeiten mit Gründern über Sweat Equity zusammen — mit Strategie, Design, Technologie und Wachstum.", tags: ["Sweat Equity", "Produktdesign", "Wachstum", "Mitgründung", "Skalierung"], cta: "Unseren Ansatz ansehen" },
    },
    services: {
      kicker: "Branchenführende Lösungen",
      heading: ["Für die Anforderungen", "Ihrer Branche entwickelt."],
      subtitle: "Wir verbinden Ingenieurskunst und Vorstellungskraft, um Lösungen zu schaffen, die bessere Erlebnisse, höhere Conversions und stärkere Bindungen fördern — in großem Maßstab.",
      items: [
        { title: "Fintech", desc: "Intelligente, umsatzorientierte Finanzökosysteme — jenseits von Transaktionen." },
        { title: "KI-Automatisierung", desc: "Agentische Workflows, die sich anpassen, sprechen, lernen und skalieren." },
        { title: "Telekom", desc: "Wir helfen Telkos, sich von Infrastrukturanbietern zu Techkos zu entwickeln." },
        { title: "Luftfahrt", desc: "Flugreisen neu gedacht als vernetzte, datengetriebene Reise." },
        { title: "Immersiv & Loyalität", desc: "Sinnesgetriebene Ökosysteme und Loyalitätsmotoren, die sich wie Erlebnisse anfühlen." },
        { title: "Produkt & Plattform", desc: "Von der Modernisierung der Kernsysteme bis zu Erlebnissen der nächsten Generation, durchgängig entwickelt." },
      ],
      stats: ["Gegründet in Stockholm", "Arten der Zusammenarbeit", "Durchschn. erste Antwort", "Gründergeführte Umsetzung"],
    },
    business: {
      kicker: "Für kleine und lokale Unternehmen",
      heading: ["Handwerk wie im Top-Studio.", "Zum Budget für Kleinunternehmen."],
      subtitle: "Jedes lokale Unternehmen verdient eine Website, die Kunden gewinnt. Wir helfen Läden, Studios und Dienstleistern in ganz Europa, etwas Schönes und Schnelles zu launchen — ohne Fachjargon und ohne Agenturpreis.",
      includedTitle: "Das bekommen Sie",
      included: [
        "Eine maßgeschneiderte Website — für Sie gestaltet, keine Vorlage",
        "Mobile-first und blitzschnell",
        "Google-bereit mit lokaler SEO",
        "Buchungen, Kontakt und Anfragen integriert",
        "In etwa zwei Wochen live",
        "Ein klarer, fester Preis — keine Überraschungen",
      ],
      cta: "Bringen Sie Ihr Unternehmen online",
      featuredLabel: "Live-Kunde · unsere erste Auslieferung",
      featuredName: "Bernedotter",
      featuredSector: "Gartenpflege · Öland & Kalmar",
      featuredDesc: "Eine warme, persönliche Marken- und Buchungsseite für ein Ein-Personen-Gartenstudio auf Öland — sauber, schnell und mühelos zu betreiben.",
      viewLive: "Website ansehen",
    },
    marquee: ["Stockholm HQ", "Fintech", "KI-Automatisierung", "Kleinunternehmen", "Websites", "Sweat Equity", "Unternehmensaufbau", "Immersiv"],
    ventures: {
      kicker: "Investitionsfokussierter Unternehmensaufbau",
      heading: ["Gemeinsam verwandeln wir gute", "Ideen in großartige Unternehmen."],
      chapters: [
        { title: "Die Idee", desc: "Wir treffen Gründer früh. Wir stellen die Vision auf die Probe, schärfen die Strategie und validieren den Markt — bevor eine einzige Zeile Code geschrieben wird." },
        { title: "Die Umsetzung", desc: "Unser Team arbeitet Seite an Seite mit Ihnen. Wir liefern herausragende digitale Produkte schnell und verbinden Geschäftsstrategie, Design, Technologie und KI." },
        { title: "Das Eigenkapital", desc: "Wir stehen hinter dem, was wir bauen. Über Sweat Equity werden wir Teil des Unternehmens — engagiert, investiert und entschlossen, es mit Ihnen zu skalieren." },
      ],
      founding: {
        label: "Nehmen jetzt auf · 2026",
        heading: "Werden Sie eines unserer ersten Unternehmen",
        desc: "Wir sind ein brandneues Studio und wählen eine kleine Gründungsgruppe von Gründern aus, mit denen wir bauen — tiefgehend und gegen Beteiligung. Wenn Sie früh dran und ambitioniert sind, ist ein Platz am Tisch frei.",
        cta: "Pitchen Sie uns Ihre Idee",
      },
    },
    about: {
      kicker: "Über uns — Stockholm, Schweden",
      heading: ["Nordisches Handwerk.", "Europäischer Anspruch."],
      p1: "NOWI ist ein junges Stockholmer Studio und Venture-Partner, gebaut für die Art, wie Wirtschaft 2026 funktioniert. Wir sind klein, praxisnah und gründergeführt — und behandeln jedes Projekt wie unser eigenes.",
      p2: "Ob wir die Website eines lokalen Ladens ausliefern oder ein Startup mitaufbauen — der Anspruch ist derselbe: die bestmöglichen Bedingungen dafür zu schaffen, dass gute Ideen Erfolg haben und wachsen.",
      stats: [["EU", "Für Europa gebaut"], ["2026", "Gegründet in Stockholm"], ["∞", "Ideen willkommen"]],
      localeImage: "https://images.pexels.com/photos/37120347/pexels-photo-37120347.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      localeCaption: "Berlin — Deutschland",
    },
    contact: {
      kicker: "Kontakt — Sprechen wir",
      heading: ["Pitchen Sie Ihr Unternehmen", "oder bringen Sie es online."],
      name: "Ihr Name", email: "E-Mail", company: "Unternehmen (optional)",
      interestLabel: "Ich interessiere mich für",
      interests: ["Eine Website für mein Unternehmen", "Unternehmen / Investition", "Digitale Lösungen", "Etwas anderes"],
      message: "Erzählen Sie uns von Ihrem Unternehmen oder Ihrer Idee",
      send: "Nachricht senden", sending: "Senden",
      igLine: "Lieber ein Live-Chat? Schreiben Sie uns auf WhatsApp — wir antworten schnell.",
      igLabel: "Instagram-DM", emailLabel: "E-Mail", studioLabel: "Studio", studioValue: "Stockholm, Schweden",
      toastSuccess: "Nachricht erhalten. Wir melden uns in Kürze.",
      toastError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
      toastValidation: "Bitte Name, E-Mail und Nachricht ausfüllen.",
    },
    footer: {
      tagline: "Wir bauen. Wir investieren. Von Stockholm, für Europa.",
      exploreLabel: "Entdecken", connectLabel: "Kontakt", startProject: "Projekt starten",
      rights: "© 2026 NOWI — Alle Rechte vorbehalten",
    },
    consult: { kicker: "Kostenlose Beratung", heading: ["Buchen Sie ein kostenloses", "15-Minuten-Gespräch."], subtitle: "Kein Druck, kein Fachjargon — nur 15 Minuten, um über Ihre Website, Ihr Produkt oder Ihre Idee zu sprechen und zu sehen, ob wir zusammenpassen." },
    legal: { footerLink: "Impressum", title: "Impressum", intro: "Unternehmensangaben gemäß geltendem schwedischem und EU-Recht.", company: "Unternehmen", org: "Registernummer", vat: "USt-IdNr.", office: "Sitz", contact: "Kontakt", responsible: "Verantwortlich für den Inhalt", back: "Zurück zur Startseite", disclaimer: "NOWI ist der Markenname der NOWI Skills AB. Alle Inhalte dieser Website dienen der allgemeinen Information und können ohne Vorankündigung geändert werden." },
  },
};

export const LANGS = [
  { code: "en", path: "/", label: "EN", full: "English" },
  { code: "sv", path: "/se", label: "SV", full: "Svenska" },
  { code: "da", path: "/dk", label: "DA", full: "Dansk" },
  { code: "nb", path: "/no", label: "NO", full: "Norsk" },
  { code: "fi", path: "/fi", label: "FI", full: "Suomi" },
  { code: "is", path: "/is", label: "IS", full: "Íslenska" },
  { code: "de", path: "/de", label: "DE", full: "Deutsch" },
];
